import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnviromentComponent } from './enviroment/enviroment.component';
import { IndustrialComponent } from './industrial/industrial.component';
import { RouterModule, Routes } from '@angular/router';
import { SolutionComponent } from './solution.component';
import { MatDialogModule } from '@angular/material/dialog';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { TranslateModule } from '@ngx-translate/core';
import { RawviewComponent } from './rawview/rawview.component';
import { EmesentComponent } from './emesent/emesent.component';

const routes:Routes = [
  {
    path: '',
    component: SolutionComponent
  },
  {
    path: 'ambiental',
    component: EnviromentComponent
  },
  {
    path: 'industrial',
    component: IndustrialComponent
  },
  {
    path: 'industrial/rawview',
    component: RawviewComponent
  },
  {
    path: 'industrial/emesent',
    component: EmesentComponent
  }
]

@NgModule({
  declarations: [EnviromentComponent, IndustrialComponent, SolutionComponent,RawviewComponent, EmesentComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    TranslateModule.forChild(),
    RouterModule.forChild(routes),
    IvyCarouselModule
  ]
})
export class SolutionModule { }
